export const DEFAULT_START_TIME = '00:00';
export const DEFAULT_END_TIME = '23:59';
export const DEFAULT_TIMEZONE = 'UTC';
